import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
// import { toJS } from 'mobx';
import 'react-block-ui/style.css';
import LaddaButton, { S, SLIDE_LEFT } from 'react-ladda';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { TIMEOUT_PLACEHOLDER } from '../../helpers/constants';
import { TCS_MSG, TCS_PDF_TCS } from '../../helpers/messageText';
import TsAndCs from '../PublicArea/components/TermsAndConditions';
import store from '../../stores/store';
import './ModalPopup.css';

const ModalPopup = observer(
    class ModalPopup extends React.Component {

        buildMessage = () => {
            let message = store.alert.message.replace(
                TIMEOUT_PLACEHOLDER,
                store.alert.timerCounter,
            );

            switch (message) {
                case TCS_MSG:
                    return <TsAndCs />;

                default:
                    return <div>{message}</div>;
            }
        }

        render() {
            const { show } = this.props;


            return (
                <div className="col-xs-auto text-right">
                    <Modal className="modal-lg" isOpen={show} autoFocus={false}>
                        <ModalHeader>
                            <p className="modal-title">{store.alert.heading}</p>
                        </ModalHeader>
                        <ModalBody>
                            <div className="text-left">
                                {this.buildMessage()}
                            </div>
                        </ModalBody>
                        <ModalFooter>
							{
								(TCS_MSG === store.alert.message) ? (
	                                <a
	                                    className="btn btn-outline-primary"
	                                    data-dismiss="modal"
										rel="noopener noreferrer"
	                                    href={TCS_PDF_TCS}
	                                >
	                                    Download
	                                </a>
	                            ) : null}
                            {store.alert.cancelLable.length !== 0 ? (
                                <a
                                    className="btn btn-outline-primary"
                                    data-dismiss="modal"
                                    onClick={store.alert.cancelFunction}
									href="#"
                                >
                                    {store.alert.cancelLable}
                                </a>
                            ) : null}
                            <LaddaButton
                                className="btn btn-primary"
                                onClick={store.alert.submitFunction}
                                data-size={S}
                                data-style={SLIDE_LEFT}
                                data-spinner-size={30}
                                data-spinner-color="#fff"
                                data-spinner-lines={12}
                            >
                                {store.alert.submitLabel}
                            </LaddaButton>
                        </ModalFooter>
                    </Modal>
                </div>
            );
        }
    },
);

ModalPopup.propTypes = {
    show: PropTypes.bool.isRequired,
};

export default ModalPopup;



// WEBPACK FOOTER //
// ./src/containers/_shared/ModalPopup.js